import { render, staticRenderFns } from "./SellCoinsRatioAdjustModal.vue?vue&type=template&id=653a3bf4&scoped=true&"
import script from "./SellCoinsRatioAdjustModal.vue?vue&type=script&lang=ts&"
export * from "./SellCoinsRatioAdjustModal.vue?vue&type=script&lang=ts&"
import style0 from "./SellCoinsRatioAdjustModal.vue?vue&type=style&index=0&id=653a3bf4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653a3bf4",
  null
  
)

export default component.exports